<template>
  <div @click="copy($event)"><slot /></div>
</template>

<script>
export default {
  name: 'CopyToClipboard',
  props: {
    value: {
      default: '',
      required: false,
      type: String
    }
  },
  setup: (props, { emit }) => ({
    copy($event) {
      window.navigator.clipboard.writeText(props.value);
      emit('copy', props.value, $event);
    }
  })
};
</script>
